import * as React from "react";
import Merchant from "common/Merchant";

import "./Settings.css";
import SettingsInfo from "./SettingsInfo";
import SettingsApi from "./SettingsApi";

export interface SettingsProps {
  secretKey: string;
  receiptPage: string;
  merchants: Array<Merchant>;
  pages: Array<any>;
  nonce: string;
}

export interface AffiniOptions{
  data?: SettingsProps;
}

export class Settings extends React.Component<SettingsProps, any> {
  private readonly provider = new SettingsApi(this.props.nonce);
  private formData = {};

  public constructor(props: any) {
    super(props);
    this.state = props;
    this.formData = { secretKey : props.secretKey, receiptPage: props.receiptPage };
  }

  private onChange = (e: React.ChangeEvent<any>) =>{
    let target = e.currentTarget;
    this.formData[target.name] = target.value;
  };

  private formOnSubmit = () => {
    this.provider.save(this.formData)
       .then(result => this.setState(result))
        .catch(error => this.setState({ error: error.message, merchants: [] }));
  };

  public render() {
    const { secretKey, receiptPage, pages } = this.state;

    return (
      <div className="Settings">
        <h1>AffiniPay Payment Gateway Settings</h1>
        <div className="sections">
          <div className="section main">
            <h3>Current Configuration</h3>

                <form id="syntax-form">
                  <label htmlFor="secretKey">Secret Key</label>
                  <span className="error">{this.state.error}</span>
                  <input
                    type="text"
                    name="secretKey"
                    onChange={this.onChange}
                    defaultValue={secretKey}
                  />
                  <label htmlFor="receiptPage">Receipt Page</label>
                  <select name="receiptPage"
                          defaultValue={receiptPage}
                          onChange={this.onChange}>
                    <option value="new">(Default Receipt Page)</option>
                    {pages.map((page, i) => (
                      <option value={page.id} key={i}>
                        {page.title}
                      </option>
                    ))}
                  </select>

                  <button
                    onClick={this.formOnSubmit}
                    type="button">Save Settings</button>
                </form>
          </div>
          <SettingsInfo merchants={this.state.merchants} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/settings/Settings.tsx